<!--
 * @Author: chengleilei
 * @Date: 2025-09-18 11:12:11
 * @Description: 采购单列表
-->
<template>
    <div>
        <PageHeader title="采购单" hidden-breadcrumb>
            <Button slot="action" type="primary" @click="goPage">新增采购单</Button>
        </PageHeader>
        <Card :bordered="false" dis-hover class="ivu-mt">
            <TableFormNew ref="tableFormNewRef" :formList="formList" @onSubmit="onSubmit" @onReset="onReset">
                <Button class="ivu-ml-8" slot="extraBtn" type="error" @click="exportData">导出</Button>
            </TableFormNew>
            <TablePage :list="tableConfig" @onPageChange="onPageChange" @onPageSizeChange="onPageSizeChange" />
        </Card>
    </div>
</template>

<script>
import TableFormNew from '@/components/tableFormNew';
import TablePage from '@/components/tablePage';
import { apiBrandingCompanyList } from '@/api/purchase';
import { dateRangeTmplItem } from '@/components/tableFormNew/common/dateItem';
import { apiPurchaseOrderList, apiPurchaseOrderExport } from '@/api/purchase';
import { clearInvalidKey } from '@/libs/util.tool';
import { jumpPage, renderButton } from '@/libs/util';
import { purchaseOrderColumns } from './const';
import { purchaseOrderStatusDict } from '@/dicts';

export default {
    components: { TableFormNew, TablePage },
    data() {
        return {
            formList: [
                { type: 'input', label: '采购单号', prop: 'orderNo' },
                {
                    type: 'select',
                    label: '品牌商',
                    prop: 'brandingCompanyId',
                    options: [],
                    loading: true,
                    filterable: true,
                },
                {
                    type: 'select',
                    label: '状态',
                    prop: 'status',
                    options: purchaseOrderStatusDict,
                },
                {
                    ...dateRangeTmplItem,
                    label: '制单时间',
                    prop: ['startTime', 'endTime'],
                    isJoinTimeSuffix: true,
                },
            ],
            tableConfig: {
                current: 1,
                size: window.$pageSize,
                total: 0,
                columns: [
                    ...purchaseOrderColumns,
                    {
                        title: '操作',
                        width: 80,
                        fixed: 'right',
                        render: (h, p) => {
                            return [
                                renderButton(h, { text: '详情', type: 'primary' }, () => {
                                    this.goDetail(p.row);
                                }),
                            ];
                        },
                    },
                ],
                data: [],
                loading: false,
            },
        };
    },
    activated() {
        this.getCorrelationCompany();
        this.getData();
    },
    methods: {
        // 获取品牌商列表（关联的）
        async getCorrelationCompany() {
            this.formList[1].loading = true;
            try {
                const res = await apiBrandingCompanyList();
                this.formList[1].loading = false;
                if (!res || res.length <= 0) {
                    this.formList[1].options = [];
                    return false;
                }
                this.formList[1].options = res.map((item) => {
                    return {
                        label: item.name,
                        value: item.id,
                    };
                });
            } catch (error) {
                this.formList[1].options = [];
                this.formList[1].loading = false;
            }
        },
        // 获取参数
        getParams() {
            const formData = this.$refs['tableFormNewRef'].getFormData();
            const params = {
                current: this.tableConfig.current,
                size: this.tableConfig.size,
                ...formData,
            };
            return clearInvalidKey(params);
        },
        // 获取列表数据
        async getData() {
            try {
                this.tableConfig.loading = true;
                const res = await apiPurchaseOrderList(this.getParams());
                this.tableConfig.total = Number(res.total);
                this.tableConfig.data = res.list;
            } finally {
                this.tableConfig.loading = false;
            }
        },
        // 导出
        async exportData() {
            try {
                this.$Message.loading({ content: '导出中...', duration: 0 });
                await apiPurchaseOrderExport(this.getParams());
                this.$Modal.confirm({
                    title: '提示',
                    content: `您好！“${this.$route.meta.title}”正在导出，请稍后在“导出列表”模块中查看，谢谢！`,
                    onOk: () => {
                        console.log('export');
                    },
                });
            } finally {
                this.$Message.destroy();
            }
        },
        // 查询
        onSubmit() {
            this.tableConfig.current = 1;
            this.getData();
        },
        // 重置
        onReset() {
            this.tableConfig.current = 1;
            this.tableConfig.size = window.$pageSize;
            this.getData();
        },
        // current-change
        onPageChange(val) {
            this.tableConfig.current = val;
            this.getData();
        },
        // size-change
        onPageSizeChange(val) {
            this.tableConfig.current = 1;
            this.tableConfig.size = val;
            this.getData();
        },
        // 跳转详情
        goDetail(row) {
            this.$router.push({
                path: './detail',
                query: { id: row.id },
            });
            jumpPage({
                path: '/sub-vue2/purchase/purchaseOrder/detail',
                params: { id: row.id },
            });
        },
        // 跳转新增
        goPage() {
            jumpPage({
                path: '/sub-vue2/purchase/purchaseOrder/add',
            });
        },
    },
};
</script>
